<h2 mat-dialog-title *ngFor="let section of section_data">
    {{section.section_title}}
    <a (click)="onCancel()">
        <i class="fa fa-times pointer pt-2 pr-3 float-right"></i>
    </a>
</h2>
<mat-dialog-content>
    <div class="pt-2" *ngFor="let section of section_data">
        <tm-dynamic-form *ngIf="masters && section_data" [section_list]="[(section|JSONParser)]" [masters]="masters" [display_type]="display_type"
            [dynamic_form]="dynamic_form" [parentCellClicked]="CellClicked" [callback_func]="callbackFuncRef">
        </tm-dynamic-form>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row mt-1">
        <div class="col-md-12 " *ngFor="let section of section_data">
            <button [disabled]="loading" class="float-right  ml-1 btn btn-sm save-btn w-100" (click)="dynamicFormSave(section, section.multiple ? section.multiple_form : dynamic_form.get([section.section_id]))">
                <div *ngIf="loading" style="text-align: center;">
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
                <span *ngIf="!loading">
                    {{ '21_9972_9897_1032' | translate}}
                </span>
            </button>
            <!-- <button class="float-right ml-auto btn btn-sm btn-danger" (click)="cancel()">
                Cancel
            </button> -->
        </div>
    </div>
</mat-dialog-actions>